export default {
  "content": "<g stroke=\"#636360\"><rect height=\"23.111\" rx=\"2.222\" stroke-width=\".889\" width=\"13.047\" x=\".444\" y=\".444\"/><path d=\"M4.645 3.871H9.29\" stroke-linecap=\"round\" stroke-width=\"1.333\"/><path d=\"M6.968 20.351a.996.996 0 100-1.993.996.996 0 000 1.993z\" fill=\"#636360\" stroke-width=\".444\"/></g>",
  "attrs": {
    "fill": "none",
    "height": "24",
    "viewBox": "0 0 14 24",
    "width": "14",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};